import { MedicalImagesType } from "./MedicalImagesEnum";

export const SpinesimSurgeryViewType = {
  LATERAL: "LATERAL",
  FRONTAL: "FRONTAL",
  ALL: "ALL",
};

export const MapViewNameToSpinesimSurgeryViewType = viewName => {
  switch (viewName) {
    case MedicalImagesType.LATERALDX:
    case MedicalImagesType.LATERAL_SURGERY_DX:
    case MedicalImagesType.LATERAL_VALIDATION_DX:
    case MedicalImagesType.LATERAL_SUPPORT_SURGERY:
      return SpinesimSurgeryViewType.LATERAL;
    case MedicalImagesType.FRONTDX:
    case MedicalImagesType.FRONT_SURGERY_DX:
    case MedicalImagesType.FRONT_VALIDATION_DX:
      return SpinesimSurgeryViewType.FRONTAL;
    case MedicalImagesType.SAGITTAL:
    case MedicalImagesType.CORONAL:
    case MedicalImagesType.AXIAL:
      return SpinesimSurgeryViewType.ALL;
    default:
      return SpinesimSurgeryViewType.ALL;
  }
};
